import Builder from 'react-native-jala-orm/src/model/Builder';
import _ from 'lodash';
import Expression from 'react-native-jala-orm/src/query/Expression';
import SyncableModel from './SyncableModel';
import Cycle from './Cycle';
import File from './File';

export default class Sampling extends SyncableModel {
    static name = 'Sampling'

    _fillable = [
      'id', 'cycle_id', 'average_weight',
      'survival_rate', 'sampled_at', 'remark', 'state',
      'created_at', 'updated_at', 'synced_at', 'deleted_at',
    ]

    static _childs = ['files'];

    static _parents = ['cycle'];

    static endpoint = '/samplings'

    static allowReplaceUpdate = true

    _casts = {
      average_growth: 'float',
      state: 'object'
    }

    static _boot() {
      super._boot();

      this.addGlobalScope('global', (query: Builder) => {
        if (_.isEmpty(query.getQuery().columns)) {
          query.select([query.qualifyColumn('*')]);
        }

        const cycle = (new Cycle()).setTable(`${query.getModel().getTable()}_cycles`);
        query.leftJoin(
          `${(new Cycle()).getTable()} as ${cycle.getTable()}`,
          cycle.getQualifiedKeyName(), query.qualifyColumn(cycle.getForeignKey())
        );
      });

      this.updating((sampling: Sampling) => {
        if (sampling.isDirty(sampling.getKeyName())) {
          sampling.relationFiles()
            .update({
              fileable_id: sampling.getKey()
            });
        }
      });
    }

    qualifyColumn(column: string): string {
      if (column === '*') {
        return new Expression(
          `${this.getTable()}.*, `
            + `${this.qualifyColumn('average_growth')} as average_growth, `
            + `${this.qualifyColumn('age')} as age`
        );
      }
      if (column === 'average_growth') {
        const sampling = (new Sampling()).setTable(_.uniqueId('t'));
        const samplingQuery = Sampling.query().withoutGlobalScopes()
          .select([
            new Expression('('
              + `(${this.qualifyColumn('average_weight')} - AVG(${sampling.qualifyColumn('average_weight')})) / `
              + `CAST((JULIANDAY(${this.qualifyColumn('sampled_at')}) - JULIANDAY(${sampling.qualifyColumn('sampled_at')})) AS INTEGER))`)
          ])
          .table(this.getTable(), sampling.getTable())
          .whereColumn(sampling.qualifyColumn('cycle_id'), this.qualifyColumn('cycle_id'))
          .whereColumn(sampling.qualifyColumn('sampled_at'), '<', this.qualifyColumn('sampled_at'))
          .groupBy(sampling.qualifyColumn('sampled_at'))
          .orderByDesc(sampling.qualifyColumn('sampled_at'))
          .take(1);
        return new Expression(`(${samplingQuery.toSql()})`);
      }
      if (column === 'age') {
        const cycle = (new Cycle()).setTable(`${this.getTable()}_cycles`);
        return new Expression(
          '('
            + 'CAST('
              + `(JULIANDAY(${this.qualifyColumn('sampled_at')}) - `
              + `JULIANDAY(${cycle.qualifyColumn('started_at')})) AS INTEGER`
            + `) + COALESCE(${cycle.qualifyColumn('initial_age')}, 0)`
          + ')'
        );
      }
      return super.qualifyColumn(column);
    }

    relationCycle() {
      return Cycle.query().whereKey(this.cycle_id);
    }

    relationFiles() {
      return File.query()
        .where(new File().qualifyColumn('fileable_id'), this.getOriginal(this.getKeyName()) || this.getKey())
        .where(new File().qualifyColumn('fileable_type'), 'App\\Sampling');
    }
}
